module.exports = __webpack_public_path__ + "static/img/28.aa190e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/28.jpg
// module id = gEvE
// module chunks = 0